import { useMemo } from "react";

import type { CheckoutContextProps } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { DETAILED_BACKGROUND_COLOR } from "@/react/helpers/paywallCustomizationHelpers";

import { PaywallCustomization } from "..";
import { usePaywallCustomizationContext } from "../PaywallCustomizationProvider";
import type { OfferContent } from "./OfferTemplate";

interface UseDetailedOfferContentOptions {
  isPreviewing?: boolean;
  shouldHideBadges?: boolean;
}

export const useDetailedOfferContent = (
  paywall: CheckoutContextProps["paywall"],
  { isPreviewing }: UseDetailedOfferContentOptions = {},
): OfferContent => {
  const { paywallCustomization } = usePaywallCustomizationContext();

  return useMemo(() => {
    const backgroundColor =
      paywallCustomization?.detailed_properties?.background_color ||
      DETAILED_BACKGROUND_COLOR;
    const shouldShowCountdown = true;

    const header = (
      <PaywallCustomization.Detailed paywall={paywall}>
        <PaywallCustomization.Badges className="justify-center" />
      </PaywallCustomization.Detailed>
    );

    const cover = (
      <PaywallCustomization.Detailed.Cover
        isPreviewing={isPreviewing}
        mediaClassName="rounded-2xl"
      />
    );

    return {
      backgroundColor,
      cover,
      header,
      shouldShowCountdown,
    };
  }, [
    paywall,
    isPreviewing,
    paywallCustomization?.detailed_properties?.background_color,
  ]);
};
